import { CommonModule } from '@angular/common'
import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core'
import { NgElement, WithProperties } from '@angular/elements'
import { registerCustomElementFactory } from '../../custom-elements/register-custom-element-factory'
import { SetItemElement } from '../set-item/set-item.component'
import { SetComponent } from '../set/set.component'

/**
 * @public
 */
export type TabSetItemElement = NgElement & WithProperties<TabSetComponent>

/**
 * @public
 */
@Component({
  selector: 'gpei-tab-set',
  templateUrl: './tab-set.component.html',
  styleUrls: [ './tab-set.component.sass' ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.ShadowDom,
  standalone: true,
  imports: [ CommonModule ]
})
export class TabSetComponent extends SetComponent {

  onTabClick(item: SetItemElement): void {
    this.activeItem = item
    this._changeDetectorRef.detectChanges()
  }

}

/**
 * @public
 */
export const registerTabSetElement = registerCustomElementFactory(TabSetComponent)
